import React from "react";
import "./CarouselFooter.scss";

const carouselText = (
  <>
    RentlyBuzz is an <span className="outlined-text">innovative</span> and
    <span className="outlined-text">affordable</span>
    <span className="outlined-text">rental management system</span> that
    streamlines property operations with comprehensive{" "}
    <span className="outlined-text">tenant screening</span>,{" "}
    <span className="outlined-text">automated rent collection</span>,{" "}
    <span className="outlined-text">maintenance tracking</span>, and{" "}
    <span className="outlined-text">real-time analytics</span> to help property
    managers maximize <span className="outlined-text">efficiency</span> while
    providing <span className="outlined-text">exceptional service</span> to
    tenants.
  </>
);

export default function CarouselFooter() {
  return (
    <div className="carousel-footer">
      <div className="carousel-footer-track">
        {carouselText}
        {/* Duplicate for seamless infinite scroll */}
        {carouselText}
      </div>
    </div>
  );
}
